<div fxLayout="column">
  <div fxLayout="row">
    <div fxFlex="auto" fxLayout="row" fxLayoutGap="1rem">
      <ng-content select="[icon]"></ng-content>

      <div fxFlex="auto" class="title">
        <ng-content select="[title]"></ng-content>
      </div>
    </div>

    <ng-content select="[tooltip]"></ng-content>
  </div>

  <ng-content select="[content]"></ng-content>
</div>
